// extracted by mini-css-extract-plugin
export default {"modalWrap":"index_modalWrap_ge7XR","showMask":"index_showMask_vPIJn"};